const Custom = (callback, message) => {
    return (val) => {
        const valid = callback(val);

        return [
            valid,
            valid ? null : (message ?? `The value entered is invalid.`),
        ]
    }
}

export default Custom;